const randomkey = (max) => Math.floor(Math.random() * max)

export default randomkey
